import { Navigate, useParams } from "react-router-dom";

export function VendorsIndexRedirect() {
  return <Navigate to="/sellers/assignments" replace />;
}

export function VendorBulkAssignRedirect() {
  return <Navigate to="/sellers/bulk-assign-escalation-manager" replace />;
}

export function VendorDetailIdRedirect() {
  const { id } = useParams();
  if (!id) {
    return <Navigate to="/sellers/assignments" replace />;
  }
  return <Navigate to={`/sellers/${id}`} replace />;
}
